// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"4f145b55","496":"203391c2","559":"83b535b3"}[chunkId] + ".css";
};